import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Italic inline component
 * Inline component for italic text emphasis
 */
const Italic = ({ children, ...props }) => {
  return (
    <Typography
      component="em"
      sx={{ fontStyle: 'italic', display: 'inline' }}
      {...props}
    >
      {children}
    </Typography>
  );
};

Italic.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Italic;
